import { Directive, HostListener, Input, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[formControlName][appCCMask]',
})
export class CCNumberMaskDirective {
  @Input() ccInputNumbers: any = {};

  constructor(public ngControl: NgControl) {}

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event);
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event) {
    this.onInputChange(event.target.value);
  }

  onInputChange(ccNumber: string) {
    const input = this.ccInputNumbers;
    const { selectionStart } = input;
    var cardNumber = ccNumber;
    if (cardNumber && typeof cardNumber === 'string' && cardNumber.length > 0) {
      let trimmedCardNum = cardNumber.replace(/\s+/g, '');

      if (trimmedCardNum.length > 16) {
        trimmedCardNum = trimmedCardNum.substr(0, 16);
      }

      /* Handle American Express 4-6-5 spacing */
      const partitions =
        trimmedCardNum.startsWith('34') || trimmedCardNum.startsWith('37')
          ? [4, 6, 5]
          : [4, 4, 4, 4];

      const numbers = [];
      let position = 0;
      partitions.forEach((partition) => {
        const part = trimmedCardNum.substr(position, partition);
        if (part) numbers.push(part);
        position += partition;
      });

      cardNumber = numbers.join(' ');
      this.ngControl.valueAccessor.writeValue(cardNumber);
      this.ngControl.control.setValue(cardNumber, {
        emitModelToViewChange: false,
      });

      /* Handle caret position if user edits the number later */
      if (selectionStart < cardNumber.length - 1) {
        input.setSelectionRange(selectionStart, selectionStart, 'none');
      }
    }
  }
}
@NgModule({
  declarations: [CCNumberMaskDirective],
  exports: [CCNumberMaskDirective],
})
export class CCNumberMaskDirectiveModule {}
